import { SeedControllerCustomerMethod } from '../methods/seed-controller/customer.method';
import { SeedControllerOrderMethod } from '../methods/seed-controller/order.method';

export class SeedController {
  public readonly customer = new SeedControllerCustomerMethod();
  public readonly order = new SeedControllerOrderMethod();
}
